import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "@/hooks/useAuth";
import { selectIsUserLoggedIn } from "@/constants/auth/auth";

const PublicRoute = () => {
  const isAuthenticated = useSelector(selectIsUserLoggedIn);
  const auth = useAuth();
  const location = useLocation();

  // Not logged in -> show public pages
  if (!isAuthenticated) return <Outlet />;

  // Logged in admin -> send to admin area
  if (auth?.user_type_id === 1) {
    return <Navigate to="/admin" replace />;
  }

  // Logged in non-admin visiting admin-auth -> do NOT redirect them away;
  // allow the admin-auth page to render (prevents redirect loop)
  if (location.pathname.startsWith("/admin-auth")) {
    return <Outlet />;
  }

  // Logged in non-admin -> send to regular user dashboard
  return <Navigate to="/sfsdashboard" replace />;
};

export { PublicRoute };